import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { signup } from "../services/companyAuthService";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const SignupForm = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    companyName: "",
    companyWebsite: "",
    companyAccountType: "",
    password: "",
    confirmPassword: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const validateForm = () => {
    const {
      firstName,
      lastName,
      email,
      phone,
      companyName,
      companyWebsite,
      companyAccountType,
      password,
      confirmPassword,
    } = formData;

    if (
      !firstName ||
      !lastName ||
      !email ||
      !phone ||
      !companyName ||
      !companyWebsite ||
      !companyAccountType ||
      !password ||
      !confirmPassword
    ) {
      toast.error("All fields are required");
      return false;
    }

    if (password !== confirmPassword) {
      toast.error("Passwords do not match");
      return false;
    }

    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d])[A-Za-z\d\S]{8,32}$/;

    const phoneRegex = /^\d{10}$/;
    if (!phoneRegex.test(phone)) {
      toast.error("Phone number must be 10 digits");
      return false;
    }

    if (!passwordRegex.test(password)) {
      toast.error("Password must be 8-32 chars, include uppercase, lowercase, number & special character");
      return false;
    }

    if (!["agencies", "brands"].includes(companyAccountType)) {
      toast.error("Please choose a valid account type");
      return false;
    }

    return true;
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   if (!validateForm()) return;

  //   setIsLoading(true);
  //   try {
  //     await signup(formData);
  //     toast.success("Signup successful. Check your email to verify your account.", {
  //       onClose: () => navigate("/company/verify-email")
  //     });
  //   } catch (err) {
  //     console.error("Signup error:", err);
  //     toast.error(err.message);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (!validateForm()) return;
    setIsLoading(true);
  
    try {
      const res = await signup(formData);
      toast.success(res.message, {
        onClose: () => navigate("/company/verify-email")
      });
    } catch (err) {
      console.error("Signup error:", err);
      toast.error(err.message || "Signup failed");
    } finally {
      setIsLoading(false);
    }
  };
  
  return (
    <div className="flex items-center justify-center flex-col gap-6 min-h-screen bg-gray-100 px-4 py-8 sm:px-6 md:px-12">
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <h1 className="text-2xl sm:text-3xl font-bold text-orange-500">
        Infuber
      </h1>
      <div className="bg-white p-4 rounded-xl shadow-lg w-full max-w-sm sm:max-w-lg md:max-w-2xl">
        <div className="text-center mb-6">
          <h5 className="mt-4 text-gray-700 font-bold">
            Hey there, new friend.
          </h5>
          <p className="text-sm sm:text-base text-gray-500">
            You're moments away from your shiny new affiliate program!
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="space-y-4">
            

            <div>
              <label className="block text-sm font-medium text-gray-700">
                First name
              </label>
              <input
                type="text"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                placeholder="Enter your first name"
                className="mt-1 w-full p-2 border rounded-lg"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">
                Last name
              </label>
              <input
                type="text"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                placeholder="Enter your last name"
                className="mt-1 w-full p-2 border rounded-lg"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">
                Email
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter your email"
                className="mt-1 w-full p-2 border rounded-lg"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Phone
              </label>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="Enter your phone number"
                className="mt-1 w-full p-2 border rounded-lg"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Company name
              </label>
              <input
                type="text"
                name="companyName"
                value={formData.companyName}
                onChange={handleChange}
                placeholder="Enter company name"
                className="mt-1 w-full p-2 border rounded-lg"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">
                Company website
              </label>
              <input
                type="url"
                name="companyWebsite"
                value={formData.companyWebsite}
                onChange={handleChange}
                placeholder="Enter company URL"
                className="mt-1 w-full p-2 border rounded-lg"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">
                Password
              </label>
              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="Enter your password"
                  className="mt-1 w-full p-2 border rounded-lg"
                  required
                />
                <span
                  className="absolute inset-y-0 right-3 flex items-center cursor-pointer text-gray-600"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FiEyeOff /> : <FiEye />}
                </span>
              </div>
              <p className="text-xs sm:text-sm text-gray-500">
                Minimum 8 characters, ideally more.
              </p>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Confirm password
              </label>
              <div className="relative">
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  name="confirmPassword"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  placeholder="Enter your password"
                  className="mt-1 w-full p-2 border rounded-lg pr-10"
                  required
                />
                <span
                  className="absolute inset-y-0 right-3 flex items-center cursor-pointer text-gray-600"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                >
                  {showConfirmPassword ? <FiEyeOff /> : <FiEye />}
                </span>
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Account Type
              </label>
              <div className="flex flex-wrap gap-4">
                <label className="inline-flex items-center gap-2 text-sm text-gray-700">
                  <input
                    type="radio"
                    name="companyAccountType"
                    value="agencies"
                    checked={formData.companyAccountType === "agencies"}
                    onChange={handleChange}
                    className="accent-orange-500"
                    required
                  />
                  Agencies
                </label>
                <label className="inline-flex items-center gap-2 text-sm text-gray-700">
                  <input
                    type="radio"
                    name="companyAccountType"
                    value="brands"
                    checked={formData.companyAccountType === "brands"}
                    onChange={handleChange}
                    className="accent-orange-500"
                    required
                  />
                  Brands
                </label>
              </div>
              <p className="text-xs text-gray-500 mt-1">
                Please choose your account type to continue.
              </p>
            </div>
            <div className="flex items-center space-x-2">
              <input type="checkbox" className="w-4 h-4" required />
              <span className="text-sm text-gray-700">I'm not a robot</span>
            </div>

            <button
              type="submit"
              disabled={isLoading}
              className={`w-full bg-orange-500 text-white py-2 rounded-lg hover:bg-orange-600 transition text-sm sm:text-base flex items-center justify-center font-medium ${isLoading ? "opacity-70 cursor-not-allowed" : ""
                }`}
            >
              {isLoading ? (
                <>
                  <svg
                    className="animate-spin h-5 w-5 mr-2 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    />
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8v2a6 6 0 000 12v2a8 8 0 01-8-8z"
                    />
                  </svg>
                </>
              ) : (
                "Sign Up"
              )}
            </button>
          </div>
        </form>
        <p className="text-xs sm:text-sm text-center text-gray-600 mt-3">
          Already have an account?{" "}
          <Link
            to="/company/login"
            className="text-orange-500 hover:text-orange-600 font-semibold"
          >
            Login
          </Link>
        </p>
        <p className="text-xs sm:text-sm text-gray-500 text-center mt-2">
          By using this website, you agree to Infuber's{" "}
          <Link to="/privacy policy" className="text-orange-500 font-medium">
            Terms of Service
          </Link>
          <span className="block sm:inline"> and </span>
          <Link to="/privacy policy" className="text-orange-500 font-medium">
            Privacy Policy
          </Link>
          .
        </p>
      </div>
    </div>
  );
};

export default SignupForm;
